import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'lucide-react';

const CookiesPolicy = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Cookies Policy - Logardt Group</title>
      </Helmet>
      <div className="min-h-screen" style={{ background: '#FAFAFA', padding: '40px 7.6923%' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 bg-transparent border px-6 py-3 cursor-pointer mb-10 text-base transition-colors hover:bg-opacity-10"
            style={{ 
              borderColor: '#E5A93D',
              color: '#0D2C22',
              borderRadius: '0px'
            }}
          >
            <ArrowLeft size={20} />
            Back to Home
          </button>

          <h1 className="mb-10" style={{ color: '#0D2C22', fontSize: '48px', fontFamily: 'Georgia, serif' }}>
            Cookies Policy
          </h1>

          <div style={{ color: '#0D2C22', fontSize: '16px', lineHeight: '1.8' }}>
            <p className="mb-5" style={{ color: '#666666' }}>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              1. What Are Cookies
            </h2>
            <p className="mb-5">
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              2. How We Use Cookies
            </h2>
            <p className="mb-5">
              Logardt Group KB uses cookies to enhance your experience on our website. We use cookies for the following purposes:
            </p>

            <h3 style={{ color: '#0D2C22', fontSize: '20px', marginTop: '30px', marginBottom: '12px', fontFamily: 'Georgia, serif' }}>
              Essential Cookies
            </h3>
            <p className="mb-5">
              These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.
            </p>

            <h3 style={{ color: '#0D2C22', fontSize: '20px', marginTop: '30px', marginBottom: '12px', fontFamily: 'Georgia, serif' }}>
              Analytics Cookies
            </h3>
            <p className="mb-5">
              These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website's functionality and content.
            </p>

            <h3 style={{ color: '#0D2C22', fontSize: '20px', marginTop: '30px', marginBottom: '12px', fontFamily: 'Georgia, serif' }}>
              Functionality Cookies
            </h3>
            <p className="mb-5">
              These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              3. Types of Cookies We Use
            </h2>
            <p className="mb-3" style={{ fontWeight: '600' }}>Session Cookies</p>
            <p className="mb-5">
              These are temporary cookies that expire when you close your browser. They help our website remember what you chose on the previous page, avoiding the need to re-enter information.
            </p>

            <p className="mb-3" style={{ fontWeight: '600' }}>Persistent Cookies</p>
            <p className="mb-5">
              These cookies remain on your device for a set period or until you delete them. They help us recognize you as a returning visitor and remember your preferences.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              4. Third-Party Cookies
            </h2>
            <p className="mb-5">
              We may use third-party services that place cookies on your device. These may include:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '20px' }}>
              <li>Google Analytics for website analytics</li>
              <li>Social media plugins</li>
              <li>Content delivery networks</li>
            </ul>
            <p className="mb-5">
              These third parties have their own privacy policies, and we have no control over their cookies.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              5. Managing Cookies
            </h2>
            <p className="mb-5">
              You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.
            </p>
            <p className="mb-5" style={{ fontWeight: '600' }}>
              How to Manage Cookies in Your Browser:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '20px' }}>
              <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
              <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
              <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
            </ul>
            <p className="mb-5">
              Please note that if you disable cookies, some features of our website may not function properly.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              6. Cookie Consent
            </h2>
            <p className="mb-5">
              By using our website, you consent to the use of cookies in accordance with this Cookies Policy. If you do not agree to our use of cookies, you should disable them by following the instructions above or refrain from using our website.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              7. Changes to This Cookies Policy
            </h2>
            <p className="mb-5">
              We may update this Cookies Policy from time to time to reflect changes in technology, legislation, our operations, or best practices. Please check this page periodically for updates.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              8. More Information
            </h2>
            <p className="mb-5">
              For more information about how we handle your data, please refer to our Privacy Policy.
            </p>

            <h2 style={{ color: '#0D2C22', fontSize: '24px', marginTop: '40px', marginBottom: '16px', fontFamily: 'Georgia, serif' }}>
              Contact Us
            </h2>
            <p style={{ marginBottom: '40px' }}>
              If you have questions about our use of cookies, please contact us through the contact form on our website.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiesPolicy;